module.exports = __webpack_public_path__ + "img/delano10.5a3a463a.jpg";